import { Controller } from "@hotwired/stimulus"

// MED-38 — the library takes files dropped straight onto it. What is dropped
// goes into the hidden upload form and is submitted, so it travels the same road
// as the upload page: one medium per file, each checked on its own, duplicates
// folded together, refusals collected into one message (MED-36).
//
// Only files count. A dragged word, a link or a picture from another page has
// nothing to do with the library and must leave the page alone.
export default class extends Controller {
  static targets = ["overlay", "form", "input"]

  connect() {
    this.depth = 0
  }

  // dragenter and dragleave fire again for every child element the pointer
  // crosses, so the overlay is counted in and out rather than toggled — without
  // the counter it flickers off the moment the pointer reaches a tile.
  enter(event) {
    if (!this.carriesFiles(event)) return

    event.preventDefault()
    this.depth++
    this.overlayTarget.classList.remove("d-none")
  }

  over(event) {
    if (!this.carriesFiles(event)) return

    // Without this the browser navigates to the file instead of handing it over.
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
  }

  leave(event) {
    if (!this.carriesFiles(event)) return

    this.depth--
    if (this.depth <= 0) this.hide()
  }

  drop(event) {
    if (!this.carriesFiles(event)) return

    event.preventDefault()
    this.hide()

    const files = event.dataTransfer.files
    if (files.length === 0) return

    this.inputTarget.files = files
    this.formTarget.requestSubmit()
  }

  hide() {
    this.depth = 0
    this.overlayTarget.classList.add("d-none")
  }

  carriesFiles(event) {
    return Array.from(event.dataTransfer?.types || []).includes("Files")
  }
}
